<template>
  <modal @before-open="beforeOpen" @opened="opened" name="bdMap" :draggable="'.header'" :reset="true" :classes="['map','generalbox']" :adaptive="true"
          :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>地图</h2>
    </div>
    <div class="content">
      <h2>地图正在建设中。。。</h2>
      <p style="display: none">{{text}}：{{center}}</p>


    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  export default {
    name: "bdMap",
    data() {
      return {
        center: {lng: 0, lat: 0},
        zoom: 12,
        text:null
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("bdMap");
      },
      beforeOpen(data){
        this.center.lng=data.params.posX;
        this.center.lat=data.params.posY;
        this.text=data.params.text;
      },
      opened(){
        this.updateModalZIndex(this.$el)
      },
      handler(){

      }
    },
    computed: {},
    mounted() {},
    filters:{},
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    & >>> .bmview
      width 100%
      height 100%
</style>


// WEBPACK FOOTER //
// src/components/service/bdMapModal.vue